import React, { useMemo } from "react"
import { Table, Tabs, Row, Col, Space } from "antd"
import { useTranslation } from "react-i18next"
import "./PlanComparisonTable.less"
import { CheckCircleOutlined, CheckCircleFilled } from "@ant-design/icons"
import PlanCardMini from "./PlanCardMini"

const PlanComparisonTable = ({ dark = false }) => {
  const { t } = useTranslation()

  const planColWidth = 324

  const iconSize = 22

  const columns = useMemo(() => {
    return [
      {
        title: <div className="big-title">{t("label:comparePlans")}</div>,
        dataIndex: "feature",
        key: "feature",
        render: val => {
          return (
            <div
              style={{
                width: 424,
                textAlign: "left",
                fontFamily: "Inter",
                fontWeight: 300,
                fontSize: 18,
              }}
            >
              {val}
            </div>
          )
        },
      },
      {
        title: (
          <PlanCardMini
            planId={process.env.GATSBY_BRAINTREE_SUBSCRIPTION_MONTHLY_PLAN_ID}
          />
        ),
        key: "monthly",
        width: planColWidth,
        render: val => {
          const active = val.monthly
          return (
            <div
              style={{
                textAlign: "center",
                color: active ? "#00B712" : "gray",
                height: iconSize
              }}
            >
              {active ? (
                <CheckCircleOutlined fill="#00B712" style={{ fontSize: iconSize }} />
              ) : (
                "-"
              )}
            </div>
          )
        },
      },
      {
        title: (
          <PlanCardMini
            planId={process.env.GATSBY_BRAINTREE_SUBSCRIPTION_SEASONAL_PLAN_ID}
          />
        ),
        key: "seasonal",
        width: planColWidth,
        render: val => {
          const active = val.seasonal
          return (
            <div
              style={{
                textAlign: "center",
                color: active ? "#00B712" : "gray",
              }}
            >
              {active ? (
                <CheckCircleOutlined fill="#00B712" style={{ fontSize: 22 }} />
              ) : (
                "-"
              )}
            </div>
          )
        },
      },
      {
        title: (
          <PlanCardMini
            planId={process.env.GATSBY_BRAINTREE_SUBSCRIPTION_ANNUAL_PLAN_ID}
          />
        ),
        key: "annual",
        width: planColWidth,
        render: val => {
          const active = val.annual
          return (
            <div
              style={{
                textAlign: "center",
                color: active ? "#00B712" : "gray",
                height: iconSize
              }}
            >
              {active ? (
                <CheckCircleOutlined fill="#00B712" style={{ fontSize: iconSize }} />
              ) : (
                "-"
              )}
            </div>
          )
        },
      },
    ]
  }, [])
  const data = useMemo(() => {
    return [
      {
        key: 1,
        feature: t("plan:subscription.feature1"),
        monthly: true,
        seasonal: true,
        annual: true,
      },
      {
        key: 1,
        feature: t("plan:subscription.feature2"),
        monthly: true,
        seasonal: true,
        annual: true,
      },
      {
        key: 1,
        feature: t("plan:subscription.feature3"),
        monthly: true,
        seasonal: true,
        annual: true,
      },
      {
        key: 1,
        feature: t("plan:subscription.feature4"),
        monthly: true,
        seasonal: true,
        annual: true,
      },
      {
        key: 1,
        feature: t("plan:subscription.feature5"),
        monthly: true,
        seasonal: true,
        annual: true,
      },
      {
        key: 1,
        feature: t("plan:subscription.feature6"),
        monthly: false,
        seasonal: false,
        annual: true,
      },
      {
        key: 1,
        feature: t("plan:subscription.feature7"),
        monthly: false,
        seasonal: false,
        annual: true,
      },
      {
        key: 1,
        feature: t("plan:subscription.feature8"),
        monthly: false,
        seasonal: false,
        annual: true,
      },
      {
        key: 1,
        feature: t("plan:subscription.feature9"),
        monthly: false,
        seasonal: false,
        annual: true,
      },
    ]
  }, [])

  const tabFeatures = useMemo(() => {
    return {
      monthly: [
        t("plan:subscription.feature1"),
        t("plan:subscription.feature2"),
        t("plan:subscription.feature3"),
        t("plan:subscription.feature4"),
        t("plan:subscription.feature5"),
      ],
      seasonal: [
        t("plan:subscription.feature1"),
        t("plan:subscription.feature2"),
        t("plan:subscription.feature3"),
        t("plan:subscription.feature4"),
        t("plan:subscription.feature5"),
      ],
      annual: [
        t("plan:subscription.feature1"),
        t("plan:subscription.feature2"),
        t("plan:subscription.feature3"),
        t("plan:subscription.feature4"),
        t("plan:subscription.feature5"),
        t("plan:subscription.feature6"),
        t("plan:subscription.feature7"),
        t("plan:subscription.feature8"),
        t("plan:subscription.feature9"),
      ],
    }
  }, [])

  return (
    <div id="plan-comparison-table" className={dark ? "dark" : "light"}>
      <Row>
        <Col xs={0} sm={0} md={24} lg={24} xl={24}>
          <Table
            columns={columns}
            dataSource={data}
            scroll={{ x: 400 }}
            pagination={{ position: ["none", "none"] }}
          />
        </Col>
        <Col xs={24} sm={24} md={0} lg={0} xl={0}>
          <h1 className="big-title" style={{ textAlign: "center", margin: 30 }}>
            {t("label:comparePlans")}
          </h1>
          <Tabs defaultActiveKey="monthly">
            <Tabs.TabPane tab={t("label:monthly")} key="monthly">
              <ul className="plan-features-mobile">
                {data.map((item, index) => {
                  return (
                    <li key={index} className="feature-row">
                      <Row justify="space-between" wrap={false}>
                        <Col flex="auto">
                          <span>{item.feature}</span>
                        </Col>
                        <Col flex="24px">
                          <div
                            style={{
                              textAlign: "center",
                              color: item.monthly ? "#00B712" : "gray",
                              width: iconSize,
                              height: iconSize
                            }}
                          >
                            {item.monthly ? (
                              <CheckCircleOutlined
                                fill="#00B712"
                                style={{ fontSize: iconSize }}
                              />
                            ) : (
                              "-"
                            )}
                          </div>
                        </Col>
                      </Row>
                    </li>
                  )
                })}
              </ul>
            </Tabs.TabPane>
            <Tabs.TabPane tab={t("label:seasonal")} key="seasonal">
              <ul className="plan-features-mobile">
                {data.map((item, index) => {
                  return (
                    <li key={index} className="feature-row">
                      <Row justify="space-between" wrap={false}>
                        <Col flex="auto">
                          <span>{item.feature}</span>
                        </Col>
                        <Col flex="24px">
                          <div
                            style={{
                              textAlign: "center",
                              color: item.seasonal ? "#00B712" : "gray",
                              width: iconSize,
                              height: iconSize                      
                            }}
                          >
                            {item.seasonal ? (
                              <CheckCircleOutlined
                                fill="#00B712"
                                style={{ fontSize: iconSize }}
                              />
                            ) : (
                              "-"
                            )}
                          </div>
                        </Col>
                      </Row>
                    </li>
                  )
                })}
              </ul>
            </Tabs.TabPane>
            <Tabs.TabPane tab={t("label:annual")} key="annual">
              <ul className="plan-features-mobile">
                {data.map((item, index) => {
                  return (
                    <li key={index} className="feature-row">
                      <Row justify="space-between" wrap={false}>
                        <Col flex="auto">
                          <span>{item.feature}</span>
                        </Col>
                        <Col flex="24px">
                          <div
                            style={{
                              textAlign: "center",
                              color: item.annual ? "#00B712" : "gray",
                              width: iconSize,
                              height: iconSize
                            }}
                          >
                            {item.annual ? (
                              <CheckCircleOutlined
                                fill="#00B712"
                                style={{ fontSize: iconSize }}
                              />
                            ) : (
                              "-"
                            )}
                          </div>
                        </Col>
                      </Row>
                    </li>
                  )
                })}
              </ul>
            </Tabs.TabPane>
          </Tabs>
        </Col>
      </Row>
    </div>
  )
}

export default PlanComparisonTable
